<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Attacher un statut</strong>
      </b-card-header>
      <b-card-body>
        <div class="row">
          <div class="col-md-7">
            <b-card no-body>
              <b-card-body>
                <b-form-group label-for="traitement">
                  <label for="traitement"><strong>Traitement</strong></label>
                  <b-form-select
                    id="traitement"
                    :plain="true"
                    :options="traitementOptions"
                    v-model="selectedTraitement"
                    :class="{hasError: errors.traitement !== ''}"
                    @change="findStatus(selectedTraitement)">
                  </b-form-select>
                  <span class="field-error">{{ errors.traitement }}</span>
                </b-form-group>
                <b-form-group>
                  <label for="status"><strong>Statuts : </strong></label>
                  <multiselect selectLabel='Appuyer pour sélectionner'
                               selectedLabel='Sélectionné'
                               deselectLabel='Appuyer pour désélectionner'
                               :close-on-select="false"
                               v-model="status"
                               id="status"
                               tag-placeholder="Choisissez un status"
                               placeholder="Par défaut aucun"
                               label="name"
                               track-by="code"
                               :options="allStatus"
                               :multiple="true"
                               :taggable="true">
                  </multiselect>
                </b-form-group>

                <b-button
                  type="button"
                  @click="attach"
                  class="pull-right mt-4"
                  size="md"
                  variant="primary">
                  Attacher
                </b-button>

              </b-card-body>

            </b-card>
          </div>
          <div class="col-md-5">
            <b-card no-body>
              <b-card-header>
                <i class="fa fa-list mr-2"></i>
                <strong>Traitements déjà rattachés à des statuts</strong>
              </b-card-header>
              <b-card-body>
                <b-list-group>
                  <b-list-group-item v-for="item in items" :key="item.id">
                    <span class="treatment-item" @click="traitementClicked(item.id)">{{ item.libelle}}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import itemList from "@/components/SortListItem";
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "AttachStatut",
    components: {
      Multiselect,
      itemList
    },
    data() {
      return {
        items: [],
        traitements: [],
        traitementOptions: [],
        selectedTraitement: '',
        allStatus: [],
        statusList: [],
        status: [],
        selectedStatus: [],
        errors: {
          traitement: "",
        },
      }
    },
    watch: {
      status: function () {
        if (this.status) {
          this.selectedStatus = this.status.map(item => item.code)
        } else {
          this.selectedStatus = []
        }
      },
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common["Accept"] = "application/json"
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getTraitements();
    },
    async mounted() {
      this.getAttachedTreatments();
      await this.getStatus();
      this.populateStatus();
    },
    methods: {
      getTraitements() {
        this.$axios
          .get("/administration/traitements")
          .then(response => {
            this.traitements = response.data.traitements;
            for (let i = 0; i < this.traitements.length; i++) {
              this.traitementOptions.push({
                text: this.traitements[i].libelle,
                value: this.traitements[i].id
              });
            }
          });
      },
      getStatus() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/administration/allDossierStatuts")
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            let parent = []
            let transition = _.groupBy(response.data.status, 'parent_id')

            for (let index in transition) {
              if (index !== 'null') {
                for(let index2 in transition[index]) {
                  if(this.statusList[index]) {
                    this.statusList[index].push(transition[index][index2])
                  } else {
                    this.statusList[index] = []
                    this.statusList[index].push(transition[index][index2])
                  }
                }
              }
            }
            for (let index in transition['null']) {
              parent[transition['null'][index].id] = transition['null'][index]
              if (this.statusList[transition['null'][index].id]) {
                this.statusList[transition['null'][index].id].unshift(transition['null'][index])
              } else {
                if(this.statusList[0]) {
                  this.statusList[0].push(transition['null'][index])
                } else {
                  this.statusList[0] = []
                  this.statusList[0].push(transition['null'][index])
                }
              }
            }

            for (let groupStatus of this.statusList) {
              if (groupStatus) {
                for (let status of groupStatus) {
                  if (status.parent_id) {
                    this.allStatus.push({code: status.id, name: status.libelle_bo+'  ('+parent[status.parent_id].libelle_bo+')'})
                  } else {
                    this.allStatus.push({code: status.id, name: status.libelle_bo})
                  }
                }
              }
            }
            // for (let status of response.data.status) {
            //   if (status.parent_id) {
            //     this.allStatus.push({code: status.id, name: status.libelle_bo+'  ('+')'})
            //   } else {
            //     this.allStatus.push({code: status.id, name: status.libelle_bo})
            //   }
            // }
          })
          .catch((error) => {
            this.handleError(this, error);
          });
      },
      populateStatus() {
        // console.log(this.allStatus)
        this.status = []
        for (let statusId of this.selectedStatus) {
          let name = ""
          for (let status of this.allStatus) {
            if (status.code === parseInt(statusId)) {
              name = status.name
              // console.log(status)
            }
          }
          this.status.push({code: statusId, name: name})
        }
      },
      attach() {
        if (this.validateFields()) {
          this.$store.commit("IS_LOADING", true);
          const dataPost = {
            status: this.selectedStatus,
          };
          this.$axios
            .post("/administration/traitements/attachStatus/" + this.selectedTraitement, dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.getAttachedTreatments();
              this.getTraitements();
              this.$swal({
                position: "top",
                type: "success",
                title: "Félicitations !",
                text: "Traitement attaché avec succès",
                showConfirmButton: false,
                timer: 3500
              });
            })
            .catch((error) => {
              this.handleError(this, error);
            });
        }
      },
      handleError(self, error) {
        console.log('error : ', error);
        self.$store.commit("IS_LOADING", false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 5000
        });
      },
      validateFields() {
        let isValid = true
        if(this.selectedTraitement === '') {
          this.errors.traitement = 'Veuillez choisir un traitement'
          isValid = false
        }
        return isValid;
      },
      findStatus(id) {
        this.status = []
        const traitement = this.traitements.find((el) => el.id === id)
        const status = traitement.status
        if (status.length > 0) {
          for (let j = 0; j < status.length; j++) {
            this.selectedStatus.push(status[j].id)
            // this.status.push({code: status[j].id, name: status[j].libelle_bo+'  ('+status[j].libelle_sous_status_bo+')'})
          }
          this.populateStatus()
        } else {
          this.status = []
        }
      },
      getAttachedTreatments() {
        this.$axios
          .get('/administration/attachedTraitements')
          .then(response => {
            this.items = response.data.traitements;
          });
      },
      traitementClicked(id) {
        this.selectedTraitement = id
        this.selectedStatus = []
        this.findStatus(id)
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .treatment-item {
    cursor: pointer;
  }
</style>

